export default function () {
  return {
    items: [],
    utileCurrentPage: 1,
    utileLastPage: 1,
    utilePerPage: 0,
    utileTotal: 0,
    indexPage: null,
    search: '',
    pageutileLoading: false,
  }
}
